<script setup lang="ts">
import { useSlotValidation } from "@/composables/useSlotValidation";

import Button from "../buttons/Button.vue";

interface CardProps {
    title?: string;
    close?: boolean;
    action?: boolean;
    noPadding?: boolean;
    noPaddingHeader?: boolean;
    noPaddingFooter?: boolean;
    centerHeader?: boolean;
    contentOverflow?: string;
    hideScrollbar?: boolean;
}

defineProps<CardProps>();

const emit = defineEmits<(name: "close", event: MouseEvent) => void>();

const handleClose = (e: MouseEvent) => emit("close", e);

const slots = useSlotValidation("header", "default", "footer");
</script>
<template>
    <div class="modal-card">
        <div v-if="slots.header || title || close" :class="['modal-card-header', { action, centerHeader, noPaddingHeader }]">
            <slot name="header">
                <h3 class="modal-card-header-title" v-if="title">{{ title }}</h3>
            </slot>
            <Button v-if="close" class="close-btn" icon-only="x" type="neutral" variant="ghost" size="xs" @click="handleClose"></Button>
        </div>
        <div v-if="slots.default" :class="['modal-card-content', { noPadding, hideScrollbar }]" :style="{ overflow: contentOverflow }">
            <slot></slot>
        </div>
        <div v-if="slots.footer" :class="['modal-card-footer', { action, noPaddingFooter }]">
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<style scoped lang="scss">
.modal-card {
    background-color: $white;
    @include regular-shadow-md;
    color: $text-main-900;
    border-radius: 12px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    width: 100%;

    .modal-card-header {
        display: flex;
        width: 100%;
        border-bottom: 1px solid $stroke-soft-200;
        padding: 16px 24px;
        gap: 12px;
        justify-content: space-between;
        align-items: center;

        &.action {
            border-bottom: none;
            padding: 16px 24px 0px;
        }

        &.centerHeader {
            align-items: center;
        }

        &.noPaddingHeader {
            padding: 0;
        }

        .modal-card-header-title {
            @include font-size-14;
            font-weight: 500;
        }

        .close-btn {
            margin-left: auto;
        }
    }
    .modal-card-content {
        padding: 24px;
        &.noPadding {
            padding: 0;
        }
        &.hideScrollbar {
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }
        height: 100%;
    }
    .modal-card-footer {
        padding: 16px 24px;
        border-top: 1px solid $stroke-soft-200;
        &.action {
            border-top: none;
            padding: 0px 24px 16px;
        }
        &.noPaddingFooter {
            padding: 0;
        }
    }
}
</style>
